import { createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import { queryClient } from './app/query-client.ts';
import { trackNavigation } from './lib/nav.ts';

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
  defaultViewTransition: false,
});

// keep an in-app history stack so "back" buttons can avoid landing on auth/onboarding
trackNavigation(router.history.location.pathname, 'PUSH');
router.history.subscribe(({ location, action }) => trackNavigation(location.pathname, action.type));

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
